/**
 * Pixel-warm palette, echoing the "Claude Code Pixel illustrations" reference:
 * terracotta characters on a cream/charcoal stage, with a violet accent that
 * marks AI agents apart from humans.
 */
export const theme = {
  bg: '#0e0f14',
  bgRoom: '#15161d',
  panel: '#1b1d26',
  panelAlt: '#23262f',
  border: '#2c2f3a',
  text: '#e8e6df',
  textDim: '#9b9a93',
  cream: '#e7dcc6',
  terracotta: '#c9735a',
  terracottaLite: '#d98a5f',
  human: '#4cc6a3',
  agent: '#8b7ff0',
  online: '#54d18c',
  away: '#e0a13a',
  offline: '#5a5d6b',
  task: '#ef9f27',
} as const

export type Theme = typeof theme
